import { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import scrollTop from '../utils/helpers/smoothScroll';

const useFilter = (defaultFilter, filterCardList = [], apartmentRooms) => {
  if (!apartmentRooms || !filterCardList) return {};

  const [currentFilter, setCurrentFilter] = useState(defaultFilter);
  const { t } = useTranslation();

  const filterValues = ['all', ...apartmentRooms];

  const filterValuesTranslations = [
    t('common.all'),
    ...apartmentRooms.map(room => room)
  ];

  const filteredList =
    useMemo(
      () =>
        filterCardList.filter(item => {
          return item.rooms === currentFilter || currentFilter === 'all';
        }),
      [currentFilter]
    ) || [];

  const buttonClickHandler = (item, ref) => {
    const container = ref.current;
    setCurrentFilter(item);
    scrollTop(
      document.documentElement || document.scrollingElement || document.body,
      container.offsetTop
    ); // It fix window.scrollTo smooth behavior at IOS(Safari)
  };

  return {
    currentFilter,
    filteredList,
    filterValues,
    filterValuesTranslations,
    buttonClickHandler
  };
};

export default useFilter;
